import { Navigate, useLocation } from 'react-router-dom';

/**
 * `/reports/smart` → `/reports`, query string intact.
 *
 * The smart report shipped one release at its own path, under a workspace that
 * held the front door. Making it the front door moves the address, and a link
 * somebody already emailed carries a whole composed question in its query — so
 * the search is passed through verbatim rather than rebuilt, and `replace`
 * keeps the dead path out of history.
 */
export function RedirectToSmart(): JSX.Element {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/reports', search }} replace />;
}

export default RedirectToSmart;
